module.exports = __webpack_public_path__ + "img/c01_unittechtriremechampion_Normal_ua.0aaa99f1.webp";